import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FeedReadPositionLabel extends BaseOption {
  static userInterfaceComponent = {
    label: "Separator text",
    component: inspectorTools.SIMPLE_INPUT,
    descriptionMessage: "Shown on the separator component above the first unread row.",
    props: {
      inputType: "text",
    },
  };

  static defaultValue = "New";
}
